// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2YTwL","title":"Images90_title__p8Qds","images":"Images90_images__2rQCI"};